module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "multi-line": true,
      "timeout": _vm.snackbarTimeout,
      "success": _vm.snackbarStatus === 'success',
      "info": _vm.snackbarStatus === 'info',
      "warning": _vm.snackbarStatus === 'warning',
      "error": _vm.snackbarStatus === 'error',
      "primary": _vm.snackbarStatus === 'primary',
      "secondary": _vm.snackbarStatus === 'secondary'
    },
    model: {
      value: (_vm.snackbarVisible),
      callback: function($$v) {
        _vm.snackbarVisible = $$v
      },
      expression: "snackbarVisible"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.message) + "\n      "), _c('v-btn', {
    staticClass: "pink--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbarVisible = false
      }
    }
  }, [_vm._v("Close")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c06c04a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RealTimeBeacon.vue
// module id = 1518
// module chunks = 9